module.exports = require('@feathersjs/socketio-client');
